import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-carbon text-muted" data-id="element-108" data-mp="3gfsmscqd8umz">
      <div className="h-1 w-full bg-lava" aria-hidden="true" data-id="element-109" data-mp="3ggu1qsai619z" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-110" data-mp="32onj8zjvni7d">
        <p className="font-display text-2xl font-bold uppercase tracking-wide text-snow" data-id="element-111" data-mp="32m1ef7odfgsu">{productShortName}</p>
        <p className="mt-3 text-sm" data-id="element-112" data-mp="3ufa3s5xf73ls">Created by geothermal energy education specialists, for educators worldwide.</p>
        <p className="mt-6 border-t border-white/10 pt-6 text-xs" data-id="element-113" data-mp="398y6cw8527j">© 2026 {productShortName} — All rights reserved.</p>
      </div>
    </footer>;
}